import { styled } from 'styled-components';

export const ScScratchActionButton = styled.div`
  width: 280px;
`;
